module.exports = {
	"id": "BG",
	"name": "Bulgaria",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.028248,
			"12": 0.007062,
			"13": null,
			"14": null,
			"15": 0.007062,
			"16": 0.042372,
			"17": null,
			"18": 0.021186,
			"19": null,
			"20": 0.007062,
			"21": 0.007062,
			"22": 0.042372,
			"23": 0.014124,
			"24": 0.007062,
			"25": 0.014124,
			"26": 0.091806,
			"27": 0.007062,
			"28": 0.007062,
			"29": 0.007062,
			"30": 0.014124,
			"31": 0.028248,
			"32": 0.014124,
			"33": 0.021186,
			"34": 0.077682,
			"35": 0.042372,
			"36": 0.028248,
			"37": 0.03531,
			"38": 0.042372,
			"39": 0.042372,
			"40": 0.127116,
			"41": 0.028248,
			"42": 0.021186,
			"43": 0.14124,
			"44": 0.056496,
			"45": 0.03531,
			"46": 0.063558,
			"47": 0.098868,
			"48": 0.098868,
			"49": 4.20189,
			"50": 0.218922,
			"51": 0.798006,
			"52": 0.42372,
			"53": 26.546058,
			"54": 7.549278,
			"55": 0.098868,
			"56": 0.021186,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.021186,
			"4": 0.007062,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.014124,
			"11": 0.021186,
			"12": 0.028248,
			"13": 0.007062,
			"14": 0.014124,
			"15": null,
			"16": 0.021186,
			"17": 0.007062,
			"18": 0.014124,
			"19": 0.007062,
			"20": 0.021186,
			"21": 0.007062,
			"22": 0.007062,
			"23": 0.014124,
			"24": 0.014124,
			"25": 0.007062,
			"26": 0.007062,
			"27": 0.007062,
			"28": 0.014124,
			"29": 0.014124,
			"30": 0.014124,
			"31": 0.028248,
			"32": 0.021186,
			"33": 0.021186,
			"34": 0.042372,
			"35": 0.028248,
			"36": 0.17655,
			"37": 0.042372,
			"38": 0.077682,
			"39": 0.063558,
			"40": 0.042372,
			"41": 0.063558,
			"42": 0.07062,
			"43": 0.240108,
			"44": 0.077682,
			"45": 0.197736,
			"46": 0.17655,
			"47": 0.889812,
			"48": 0.649704,
			"49": 13.078824,
			"50": 0.077682,
			"51": 0.014124,
			"52": 0.007062,
			"3.5": 0.028248,
			"3.6": 0.077682
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.028248,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.007062,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.007062,
			"28": 0.014124,
			"29": null,
			"30": 0.007062,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.014124,
			"36": 0.183612,
			"37": 0.042372,
			"38": 0.112992,
			"39": 0.021186,
			"40": 1.257036,
			"41": 0.225984,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": 0.007062,
			"11.5": 0.007062,
			"11.6": 0.03531,
			"12.1": 0.275418
		},
		"safari": {
			"0": null,
			"4": 0.014124,
			"5": 0.021186,
			"6": null,
			"7": 0.007062,
			"8": 0.028248,
			"9": 0.042372,
			"10": 0.374286,
			"3.1": null,
			"3.2": null,
			"5.1": 0.028248,
			"6.1": 0.014124,
			"7.1": 0.007062,
			"9.1": 0.17655
		},
		"ios_saf": {
			"8": 0,
			"10": 2.19920675271,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0592660772273,
			"8.1-8.4": 0.109491566403,
			"9.0-9.2": 0.0522345087427,
			"9.3": 0.796911094921
		},
		"android": {
			"3": 0,
			"4": 0.0470307751938,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00587884689922,
			"4.1": 0.169646724806,
			"4.2-4.3": 0.424116812016,
			"4.4": 0.972529244186,
			"4.4.3-4.4.4": 0.980927596899
		},
		"ie": {
			"6": null,
			"7": 0.0141767014925,
			"8": 0.4749195,
			"9": 0.411124343284,
			"10": 0.241003925373,
			"11": 4.55780952985,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0261369804689,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000726027235248
		},
		"edge": {
			"12": 0.049434,
			"13": 0.275418,
			"14": 0.790944
		},
		"ie_mob": {
			"10": 0.145989633803,
			"11": 0.594386366197
		},
		"bb": {
			"7": 0.0066105,
			"10": null
		},
		"samsung": {
			"0": 2.14474
		},
		"and_uc": {
			"0": 0.138086
		},
		"op_mini": {
			"0": 0.352138992296
		},
		"and_chr": {
			"0": 21.530962
		},
		"and_ff": {
			"0": 0.020566
		}
	},
	"total": 98.2196825
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BG.json
 ** module id = 476
 ** module chunks = 0
 **/